import React from "react";
import { cn } from "./utils";
import { typography } from "./tokens";

const baseCls =
  "w-full h-10 px-3 py-0 border rounded-lg outline-none transition-colors text-[13px] focus:border-blue-400 focus:bg-white";

export function RaboInput({ className, error, style, ...props }) {
  return (
    <input
      className={cn(
        baseCls,
        error ? "border-red-300 bg-red-50" : "border-gray-200 bg-gray-50 text-gray-700",
        className
      )}
      style={{ ...typography.body, ...style }}
      {...props}
    />
  );
}

const textareaCls =
  "w-full px-3 py-2.5 border rounded-lg outline-none transition-colors text-[13px] focus:border-blue-400 focus:bg-white";

export function RaboTextarea({ className, error, style, rows = 3, ...props }) {
  return (
    <textarea
      rows={rows}
      className={cn(
        textareaCls,
        error ? "border-red-300 bg-red-50" : "border-gray-200 bg-gray-50 text-gray-700",
        className
      )}
      style={{ ...typography.body, ...style }}
      {...props}
    />
  );
}

export function RaboSelect({ className, error, style, children, ...props }) {
  return (
    <select
      className={cn(
        baseCls,
        error ? "border-red-300 bg-red-50" : "border-gray-200 bg-gray-50 text-gray-700",
        className
      )}
      style={{ ...typography.body, ...style }}
      {...props}
    >
      {children}
    </select>
  );
}

export function RaboLabel({ children, required, className, style, ...props }) {
  return (
    <label
      className={cn("block text-gray-600 mb-1", className)}
      style={{ ...typography.label, color: undefined, ...style }}
      {...props}
    >
      {children}
      {required && <span className="text-red-500"> *</span>}
    </label>
  );
}
